import * as React from 'react'
import { Link } from 'react-router-dom'
import { UsernameContext } from '../App'

interface IConnect {
    isConnected : any,
    setIsConnected : any
}

//This component display in the menu either the connexion button or the user profile button looking if there is a user connected.
export const Connect: React.FunctionComponent<IConnect> = (props) => {

        const {currentUsername, setCurrentUsername} = React.useContext(UsernameContext)

        React.useEffect(() => {
            if (currentUsername) {
                props.setIsConnected(true)
            }
        }, [currentUsername])


    if (!props.isConnected) {
        return(
            <div>
                <Link to = "/connexion">Connexion / Enregistrement</Link>
            </div>
        )
    }
    else{
        return(
            <div>
                <Link to = {`/user/${currentUsername}`}><div className="UserName">{currentUsername}</div></Link>
            </div>
        )
    }

    
}